__turbopack_context__.v({
  "bottomRight": "TripleLines-module-scss-module__cTHmDW__bottomRight",
  "bottomRightImage": "TripleLines-module-scss-module__cTHmDW__bottomRightImage",
  "content": "TripleLines-module-scss-module__cTHmDW__content",
  "fullWidth": "TripleLines-module-scss-module__cTHmDW__fullWidth",
  "topLeft": "TripleLines-module-scss-module__cTHmDW__topLeft",
  "topLeftImage": "TripleLines-module-scss-module__cTHmDW__topLeftImage",
  "topRight": "TripleLines-module-scss-module__cTHmDW__topRight",
  "tripleLines": "TripleLines-module-scss-module__cTHmDW__tripleLines",
});
